import { render } from "./manager_external_urgent_packets.vue?vue&type=template&id=07b53a68"
import script from "./manager_external_urgent_packets.vue?vue&type=script&lang=js"
export * from "./manager_external_urgent_packets.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__